// src/api.js

const API_BASE = "https://boom.mouserunner.online";

let AUTH_TOKEN = null;

export function setAuthToken(token) {
  AUTH_TOKEN = token;
}

function resolveRoomId(roomOrId) {
  if (!roomOrId) return null;

  // если уже строка/число (id)
  if (typeof roomOrId === "string" || typeof roomOrId === "number") {
    return String(roomOrId);
  }

  // если объект комнаты
  if (typeof roomOrId === "object") {
    return (
      roomOrId._id ||
      roomOrId.id ||
      roomOrId.roomId ||
      roomOrId.room_id ||
      null
    );
  }

  return null;
}

async function request(path, options = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  if (AUTH_TOKEN) {
    headers["Authorization"] = `Bearer ${AUTH_TOKEN}`;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  const text = await res.text();

  // попытка JSON
  try {
    return JSON.parse(text);
  } catch {
    // если не JSON, вернём текст
    return text;
  }
}

/* -------------------------------
   AUTH
-------------------------------- */
export function verifyTelegram(initData) {
  return request("/api/auth/verify", {
    method: "POST",
    body: JSON.stringify({ initData }),
  });
}

/* -------------------------------
   USER
-------------------------------- */
export function fetchMe() {
  return request("/api/user/me");
}

/* -------------------------------
   ROOMS
-------------------------------- */
export function fetchRooms() {
  return request("/api/rooms");
}

export function joinRoom(roomOrId, premium = false) {
  const roomId = resolveRoomId(roomOrId);
  if (!roomId) {
    // чтобы сразу было понятно в консоли/ошибках фронта
    throw new Error("NO_ROOM_ID");
  }

  return request("/api/rooms/join", {
    method: "POST",
    body: JSON.stringify({ roomId, premium: !!premium }),
  });
}

export function leaveRoom(roomOrId) {
  const roomId = resolveRoomId(roomOrId);
  if (!roomId) {
    throw new Error("NO_ROOM_ID");
  }

  return request("/api/rooms/leave", {
    method: "POST",
    body: JSON.stringify({ roomId }),
  });
}


